const orginalLog = window.console.log;
if (/#\/login/.test(window.location.hash)){
    window.console.log = function(...res){
        orginalLog(...res);
        let xdf_local_log = sessionStorage.getItem('xdf_local_log') || '';
        xdf_local_log += `${new Date().toLocaleString()}--${res}; \n`;
        sessionStorage.setItem('xdf_local_log',xdf_local_log)
    }
}
